import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navigation, siteConfig } from '../../data/mock';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = !isHome || scrolled || mobileMenuOpen;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        solid
          ? 'bg-brand-ivory/95 backdrop-blur-md border-b border-brand-petrol/10 shadow-sm'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-3 md:py-4">
          <Link to="/" className="flex items-center">
            <img
              src={solid ? siteConfig.logoUrl : siteConfig.logoUrlLight}
              alt={siteConfig.name}
              className="h-14 md:h-16 w-auto object-contain"
            />
          </Link>

          <nav className="hidden lg:flex items-center space-x-10">
            {navigation.map((item) => {
              const active = location.pathname === item.path;
              return (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`relative text-sm tracking-wide font-medium transition-colors duration-300 ${
                    solid
                      ? active
                        ? 'text-brand-terracotta'
                        : 'text-brand-petrol/80 hover:text-brand-terracotta'
                      : active
                        ? 'text-brand-terracotta-light'
                        : 'text-white/90 hover:text-white'
                  }`}
                >
                  {item.name}
                  {active && (
                    <span className="absolute -bottom-1 left-0 right-0 h-px bg-brand-terracotta" />
                  )}
                </Link>
              );
            })}
          </nav>

          <button
            className={`lg:hidden p-2 transition-colors ${
              solid ? 'text-brand-petrol' : 'text-white'
            }`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menu"
          >
            {mobileMenuOpen ? <X className="h-6 w-6" strokeWidth={1.5} /> : <Menu className="h-6 w-6" strokeWidth={1.5} />}
          </button>
        </div>
      </div>

      <div
        className={`lg:hidden fixed inset-0 top-[72px] bg-brand-ivory z-40 transition-transform duration-300 ${
          mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <nav className="p-6 space-y-1">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className={`block py-3 text-lg font-display border-b border-brand-petrol/10 ${
                location.pathname === item.path
                  ? 'text-brand-terracotta'
                  : 'text-brand-petrol'
              }`}
            >
              {item.name}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Header;
